import { render, staticRenderFns } from "./approvals_footer.vue?vue&type=template&id=54c57c74&"
import script from "./approvals_footer.vue?vue&type=script&lang=js&"
export * from "./approvals_footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "approvals_footer.vue"
export default component.exports